import { format } from 'date-fns';
import { AuditLogGetData } from '~/api/def/endpoints/auditLogEndpoint';

export const generateDetails = (
  changes: AuditLogGetData['changes'],
): string => {
  const entries = Object.entries(changes);

  if (entries.length === 0) return 'No detailed information available';

  const detailsMap: {
    [key: string]: (newVal: string | number) => string;
  } = {
    name: (newVal) => `company name was updated to "${newVal}"`,
    logo: () => `company logo was updated`,
    incorporationDate: (newVal) =>
      `incorporation date was set to ${format(new Date(newVal), 'dd/MM/yyyy')}`,
    currentRound: (newVal) => `funding round to "${newVal}"`,
    companyStatus: (newVal) => `company status to "${newVal}"`,
    sectorId: () => `company sector was updated`,
    shortName: (newVal) => `short name to "${newVal}"`,
    closeDate: (newVal) =>
      `close date was set to ${format(new Date(newVal), 'dd/MM/yyyy')}`,
  };

  const formattedChanges = entries.map(([key, value]) => {
    const formatter = detailsMap[key];
    if (!formatter) {
      return `${key.charAt(0).toUpperCase() + key.slice(1)} was updated`;
    }
    return formatter(value);
  });

  if (formattedChanges.length === 1) {
    return `The ${formattedChanges[0]}.`;
  }

  const lastChange = formattedChanges.pop();
  return `The ${formattedChanges.join(', ')}${formattedChanges.length > 1 ? ',' : ''} and ${lastChange}.`;
};
